import { createI18n } from 'vue-i18n'
function requireFile(requireModule) {
  let result = {}
  requireModule.keys().forEach(fileName => {
    // 获取模块配置
    const moduleConfig = requireModule(fileName)
    const [lang] = fileName.replace(/^\.\//, '').split('/')
    if (!result[lang]) {
      result[lang] = {}
    }
    result[lang] = { ...result[lang], ...(moduleConfig.default || moduleConfig) }
  })
  return result
}

const messages = requireFile(require.context('./locales', true, /\.json$/))

const locale = (navigator.language || '').indexOf('zh') === 0 ? 'zh-CN' : 'en-US'
// 创建 i18n 实例
export const i18n = createI18n({
  legacy: false,      // 使用 Composition API 模式（推荐）
  locale,    // 默认语言
  fallbackLocale: 'en-US',  // 回退语言
  messages
})